import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCBlindMoleman extends NPC {
    constructor() {
        super(definitions.NPC_ID.BLIND_MOLEMAN);

        this.collisionRadius = 20;
        this.collisionOffsetX = 0;
        this.collisionOffsetY = -18;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_mole_idle_00"));
        
        this.addShadow(definitions.SHADOW_SIZE.SMALL, 1, new PIXI.Point(0, -6));
        this.animateIdle(0.5);
    }
}